module.exports = __webpack_public_path__ + "img/pay-welfare-bg.e35eca1d.png";